import * as React from 'react';
import  { withStyles } from '@mui/styles';

import {WithStyles, StyleRules} from '@mui/styles';
import LoadingView from '~common/components/loading-view';
import {Definition} from '~common/lib/types';
import PortalUser from '~common/lib/portal-user-context';
import RichTextEditor from '~common/components/rich-text-editor';
import {Theme} from '@mui/styles';
import {Grid, TextField, Typography} from '@mui/material';

const styles = (theme: Theme): StyleRules => ({
  container: {
    width: '100%'
  },
  sectionTitle: {
    fontSize: '1rem'
  },
  instructions: {
    padding: 15
  },
  formArea: {
  },
  formField: {
    width: "100%"
  }
});

interface Props extends React.HTMLProps<HTMLDivElement> {
  definition: Definition;
  onDefinitionChange?: (definition: Definition) => void;
}

// We will kepp internal state to give more options to the consumers, but we will always defer to the data coming from the props.
type State = {
  definition: any;
  status: 'ready' | 'loading';
};

class DefinitionEditView extends React.Component<
  Props & WithStyles<keyof typeof styles>,
  State
> {
  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props, {});
    this.state = {
      definition: props.definition,
      status: 'loading'
    };
  }

 componentDidMount() {
    // Initiate loading here is any loading is required.  Do not forget to also implement in UNSAFE_componentWillReceiveProps also
    this.setState({status: 'ready'});
  }

  UNSAFE_componentWillReceiveProps(
    newProps: Props & WithStyles<keyof typeof styles>,
    oldProps: Props & WithStyles<keyof typeof styles>
  ) {
    // When we get new props, always defer to those over internal state.  This is crucial to the predictable operation of the component parts
    // Initiate loading here is any loading is required.  Do not forget to also implement incomponentDidMount also
    this.setState({definition: newProps.definition, status: 'ready'});
  }

  handleAttributeChange = (attribute: string) => (evt: any) => {
    const {definition} = this.state;
    definition[attribute] = evt.target.value;
    this.setState({definition: definition});
    if(this.props.onDefinitionChange){
      this.props.onDefinitionChange(definition)
    }

  };

  render() {
    const {classes}: {classes: any} = this.props;
    const {status, definition} = this.state;

    var toolbarButtons: Array<any> | undefined = undefined

    // <Definition
    //   value={data["address1"]}
    //   definitionDefinition={this.getDefinitionDef("address1")}
    //   onCommitChange={this.handleCommitChange("address1")}
    // />
    switch (status) {
      case 'loading':
        return <LoadingView classes={{}} />;
        break;

      default:


        let customRendererView:any = null;

        if (PortalUser.hasOneOfFeatures(['form_development'])) {
          customRendererView = (
            <div>
              <Typography className={classes.instructions} variant="body1">
                This allows one to specify the custom renderer for the field.
                The customer renderer much be registered in the client
                application. If no customer renderer is found, the default
                rendering method will be used. Note: When a custom renderer is
                used, it is up to the developer to ensure that the custom
                renderer properly implements the field level restrictions and
                messaging controlled by the values above.
              </Typography>
              <TextField
                required={true}
                className={classes.formField}
                id="customRenderer"
                name="customRenderer"
                value={definition.customRenderer || ''}
                label=""
                onChange={this.handleAttributeChange('customRenderer')}
                InputLabelProps={{
                  shrink: true
                }}
              />
            </div>
          );
        }


        return (
          <div className={classes.container}>
            <Grid spacing={3} className={classes.formArea} container>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3} />
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <TextField
                  required={true}
                  className={classes.formField}
                  id="title"
                  name="title"
                  value={definition.title}
                  label="Title"
                  onChange={this.handleAttributeChange('title')}
                  InputLabelProps={{
                    shrink: true
                  }}
                  helperText="This is the label that is dispayed for the user"
                />
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <div className={classes.editor}>
                  <RichTextEditor
                    toolbarOnFocus
                    toolbarOptions={{
                      options: [
                        'inline',
                        'blockType',
                        'fontSize',
                        'fontFamily',
                        'list',
                        'textAlign',
                        'link',
                        'image',
                        'history'
                      ]
                    }}
                    classes={{}}
                    value={definition.instructions || ''}
                    onTextChange={this.handleAttributeChange('instructions')}
                    minHeight={20}
                    toolbarCustomButtons={toolbarButtons}
                  />
                </div>
              </Grid>
              { PortalUser.hasOneOfFeatures(['form_development']) && 
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <Typography
                    className={classes.subheading}
                    variant="subtitle1">
                    Custom Renderer
                  </Typography>
                  {customRendererView}
                </Grid>
              }
            </Grid>
          </div>
        );
    }

    return null;
  }
}

export default withStyles(styles)(DefinitionEditView);

